import React from "react";

interface IProps {
    title: string,
    value: string,
    placeholder?: string,
    disabled?: boolean,
    onClick?: () => void,
    icon?: () => any,
}

function ButtonForm(props: IProps) {
    const {title, placeholder, disabled = false, onClick, value, icon} = props
    const $icon = icon ? icon() : null
    return (
        <div className={"w-full"}>
            <p className={"relative text-gray-1 text-sm text-left "}>{title}</p>
            <button disabled={disabled} onClick={() => {
                onClick && onClick()
            }} type={"button"} value={value} placeholder={placeholder} className="inline-flex items-center space-x-2 w-full py-2 px-4 bg-gray-6 h-10 mt-1 rounded-md border border-transparent focus:border-primary focus:outline-none focus:ring-4 focus:ring-primary-light" >
                {$icon}
                <p className={`${value.length ? "text-input" : "text-gray-3"} text-sm`}>{value.length ? value : placeholder}</p>
            </button>
        </div>
    )
}

export default ButtonForm
